import { useMemo } from 'react';
import { _useMapControl as useMapControl } from 'react-map-gl';

interface LeftLayerGroupProps {
    className?: any;
    style?: any;
    children: React.ReactNode;
}

export function LeftLayerGroup(props: LeftLayerGroupProps) {
    const { children, className } = props;
    const style = useMemo(
        () => ({
            position: 'absolute',
            // width: '50%',
            ...props.style,
        }),
        [props.style]
    );

    const { containerRef } = useMapControl({
        onDragStart: (evt: any) => {
            evt.stopPropagation();
        },
        onDoubleClick: (evt: any) => {
            evt.stopPropagation();
        },
        onClick: (evt: any) => {
            evt.stopPropagation();
        },
    });

    return (
        <div style={style} className={className}>
            {/* <div  ref={containerRef}> */}
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} ref={containerRef}>
                {children}
            </div>
        </div>
    );
}

export default LeftLayerGroup;
